export default {
    SET_GENERAL_PRACTITIONERS(state, generalPractitioners) {
        state.generalPractitioners = generalPractitioners
    },
    SET_PRACTICES(state, practices) {
        state.practices = practices
    },
    SET_STATES(state, payload) {
        state.states = payload.toObject((u) => u.id)
    },
    SET_DISEASES(state, payload) {
        state.diseases = payload.toObject((u) => u.id)
    },
    SET_GENDERS(state, payload) {
        state.genders = payload.toObject((u) => u.id)
    },
    SET_INDIGENOUS_OPTIONS(state, payload) {
        state.indigenousOptions = payload.toObject((u) => u.id)
    },
    SET_URGENCIES(state, payload) {
        state.urgencies = payload.toObject((u) => u.id)
    },
    SET_REQUEST_STATUSES(state, payload) {
        state.requestStatuses = payload.toObject((u) => u.id)
    },
    SET_DISCIPLINES(state, payload) {
        state.disciplines = payload.toObject((u) => u.id)
    },
    SET_TEAMS(state, payload) {
        state.teams = payload.toObject((u) => u.id)
    },
    SET_COST_CENTRES(state, payload) {
        state.costCentres = payload.toObject((u) => u.id)
    },
    SET_ROLES(state, payload) {
        state.roles = payload.toObject((u) => u.id)
    },
    SET_SERVICE_TASK_STATUSES(state, payload) {
        state.serviceTaskStatuses = payload.toObject((u) => u.id)
    },
    SET_TASK_TYPES(state, payload) {
        payload.forEach((taskType) => {
            taskType.taskTypeFields.sort((a, b) => {
                if (a.sortOrder > b.sortOrder) {
                    return 1
                }
                if (a.sortOrder < b.sortOrder) {
                    return -1
                }
                return 1
            })

            taskType.taskTypeFields.forEach((field) => {
                if (field.taskTypeFieldOptions) {
                    field.taskTypeFieldOptions.sort((a, b) => {
                        if (a.sortOrder > b.sortOrder) {
                            return 1
                        }
                        if (a.sortOrder < b.sortOrder) {
                            return -1
                        }
                        return 1
                    })
                }
            })
        })
        state.taskTypes = payload.toObject((u) => u.id)
    },
    SET_TOGGLE_SIDE_BAR(state) {
        state.isSidebarToggled = !state.isSidebarToggled
    },
    SET_APPROVAL_CRITERIA(state, payload) {
        state.approvalCriteria = payload.toObject((u) => u.id)
    }
}
